<template>
  <div class="py-12">
    <v-row no-gutters align="center" justify="center">
      <v-col class="text-left" cols="12" sm="12" md="8">
        <h1 class="mb-8 display-1 font-weight-bold">Resetar senha</h1>
        <v-form ref="form" v-show="!successAlert" lazy-validation>
          <h4  class="mb-4 subtitle-1 font-weight-regular">Digite o e-mail cadastrado no Infohidro e enviaremos um link para você definir uma nova senha.</h4>
          <div class="form-input-group">
            <v-text-field
              id="email"
              color="secondary" 
              background-color="white"
              light
              v-model="email"
              :rules="[emailRules]"
              prepend-inner-icon="far fa-envelope"
              :append-icon="emailRules === true ? 'done' : ''"
              outlined
              required
            />
            <label for="email">E-mail</label>
          </div>
          <v-row class="ml-0 mt-4" align="center">
            <v-btn class="button-text secondary" height="50" width="180" dark large color="#0071B0" @click="recoverPassword" :loading="loading">
              Recuperar a senha
            </v-btn>            
          </v-row>
        </v-form>

        <div v-if="successAlert">
          <v-alert
            outlined
            type="success"
            text
          >
            O link para criação da sua nova senha foi enviado para o e-mail {{this.email}}.
          </v-alert>

          <v-row class="ml-0 mt-4" align="center">
            <v-btn class="button-text secondary" height="50" width="230" large @click="backLogin" :loading="loading">
              Voltar para a tela de login
            </v-btn>            
          </v-row>
        </div>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import routes from '../../router/routes';
export default {
  name: "ForgotPassword",
  data: () => ({
    email: '',
    checkbox: false,
    loading: false,
    successAlert: false
  }),
  mounted () {
    window.addEventListener('keydown', this.handleEnter)
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleEnter)
  },
  computed:{
    emailRules(){

      if(!this.email){
        return 'Você precisa inserir seu e-mail para acessar o Infohidro.';
      }

      if(/.+@.+\..+/.test(this.email) == false){
        return 'Este e-mail é inválido.';
      }

      return true;
    },
  },
  methods: {
    handleEnter (e) {
      if (e.key === 'Enter') {
        this.recoverPassword()
      }
    },
    async recoverPassword () {
      if (this.$refs.form.validate()) {
        this.successAlert = true;
      }
    },
    backLogin () {
      this.$router.push(routes.login.path);
    },
  }
}
</script>

<style scoped>

  label{
    order: -1;
    color: #ffffff
  }
  
  .v-input:focus-within + label{
    color: var(--v-secondary-lighten1);
  }

  .form-input-group{
    display: flex; 
    flex-direction: column;
  }

  .form-input-group /deep/ .v-input__icon--append .v-icon{
    color: #52B347 !important;
  }

  /* .v-text-field--outlined /deep/ .v-input__control /deep/ .v-input__slot {
      background: #ffffff !important;
  } */
  
</style>
